// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SJNG","badges":"styles_badges__1FTZd"};